var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('codemirror',{staticClass:"CodeMirror",attrs:{"id":_vm.ids,"options":_vm.options},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }